/**
 * Create Crew Page
 *
 * Admin page for inviting a new crew member.
 */

import { Link } from 'react-router-dom';
import { CrewForm } from '../../../components/crew';

export default function CreateCrewPage() {
  return (
    <div>
      {/* Breadcrumb */}
      <nav className="mb-4 text-sm">
        <ol className="flex items-center space-x-2">
          <li>
            <Link to="/admin/crew" className="text-gray-500 hover:text-gray-700">
              Crew
            </Link>
          </li>
          <li>
            <span className="text-gray-400">/</span>
          </li>
          <li className="text-gray-900 font-medium">Invite New Member</li>
        </ol>
      </nav>

      {/* Page header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Invite Crew Member</h1>
        <p className="text-gray-600 mt-1">
          Send an invitation to join your crew.
        </p>
      </div>

      {/* Form */}
      <div className="max-w-2xl">
        <CrewForm />
      </div>
    </div>
  );
}
